export const impurityItems = [
  {
    icon: "impurity",
    customLabel: "不適合品",
    to: "/impurity",
  },
  {
    icon: "composition",
    customLabel: "成分分析",
    to: "/compositions",
  },
];
